angular.module('unica_notification_template.notification_template_services')

.factory('NotificationTemplateCreateService', function($http, getBaseApiURL) {

	var notificationTemplateCreateService = {};

	notificationTemplateCreateService.create = function( eventId, notificationTemplateData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/create/' + eventId,
			data: notificationTemplateData
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_template;
			}

		});
	};

	notificationTemplateCreateService.clone = function( notificationTemplateId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/clone/' + notificationTemplateId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return notificationTemplateCreateService;

});